import { render, staticRenderFns } from "./kurulum_modal.vue?vue&type=template&id=458ac75c&scoped=true"
import script from "./kurulum_modal.vue?vue&type=script&lang=js"
export * from "./kurulum_modal.vue?vue&type=script&lang=js"
import style0 from "./kurulum_modal.vue?vue&type=style&index=0&id=458ac75c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "458ac75c",
  null
  
)

export default component.exports